/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';
import { UserMgtUsersService } from './services/user-mgt.-users.service';


/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    UserMgtUsersService,
    ApiConfiguration
  ],
})
export class UserManagementApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<UserManagementApiModule> {
    return {
      ngModule: UserManagementApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor(
    @Optional() @SkipSelf() parentModule: UserManagementApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('UserManagementApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
        'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
